import { render, staticRenderFns } from "./MercanciaGrid.vue?vue&type=template&id=716d6df5&scoped=true&"
import script from "./MercanciaGrid.vue?vue&type=script&lang=js&"
export * from "./MercanciaGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716d6df5",
  null
  
)

/* custom blocks */
import block0 from "./MercanciaGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports